<template>
  <formulaire-view
    :steps="steps"
    :step="step"
    url="/demande-inscription/"
    paramsName="creation_de_compte"
    endpoint="demande-inscription"
    :getRefs="$refs"
    :isAnonymous="isAnonymous"
    hideBackButton
  >
    <template v-slot:step="{ sas, path, setState, code }">
      <component :is="path" :sas="sas" @validation-changed="setState(path, $event)" :ref="path">
        <ressource :code="code" />
      </component>
    </template>
  </formulaire-view>
</template>

<script>
import FormulaireView from "@/components/core/views/FormulaireView.vue"

import ProcheAidant from "@/components/Formulaires/Inscription/ProcheAidant.vue"
import PersonnesAidees from "@/components/Formulaires/Inscription/PersonnesAidees.vue"
import ProfessionelSante from "@/components/Formulaires/Inscription/ProfessionelSante.vue"

export default {
  props: {
    step: String
  },
  data() {
    return {
      isAnonymous: true,
      steps: [
        { path: "introduction", code: "titre-introduction", state: "" },
        { path: "proche-aidant", code: "titre-etape-2", state: "" },
        { path: "personnes-aidees", code: "titre-etape-3", state: "" },
        { path: "professionel-sante", code: "titre-etape-4", state: "" },
        { path: "soumission", code: "titre-soumission" }
      ]
    }
  },

  components: {
    FormulaireView,
    ProcheAidant,
    PersonnesAidees,
    ProfessionelSante
  }
}
</script>
